import { RouteTabs } from '@/components/ui/route-tabs';
import { useLanguage } from '@/i18n/language-hooks';
import { useRoutePrefetch } from '@/lib/queryPrefetch';

export type OverviewTab = 'summary' | 'net-worth' | 'financial-plan';

/** Pillar-level tab strip switching between the Overview summary, net worth, and plan views. */
export function OverviewTabs({ active }: { active: OverviewTab }) {
  const { t } = useLanguage();
  const prefetch = useRoutePrefetch();

  return (
    <RouteTabs
      ariaLabel={t('overview.tabs.label')}
      activeId={active}
      onPrefetch={prefetch}
      items={[
        { id: 'summary', to: '/overview', label: t('overview.tabs.summary') },
        { id: 'net-worth', to: '/overview/net-worth', label: t('overview.tabs.netWorth') },
        {
          id: 'financial-plan',
          to: '/overview/financial-plan',
          label: t('overview.tabs.financialPlan'),
        },
      ]}
    />
  );
}
